<app-layout type="blue">
  <div id="email-otp">
    <h1>{{ 'emailOtp.title' | translate }}</h1>
    <app-icon-title-underline />

    <p>{{ 'emailOtp.description' | translate: { email: email } }}</p>

    @if (sendLoading) {
    <app-spinner></app-spinner>
    } @else {
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <app-input label="emailOtp.codeLabel" [formGroup]="form" name="code" [required]="true" />

      @if (error) {
      <div class="error-message">
        <app-icon-warning />&nbsp;
        {{ error }}
      </div>
      }

      <div class="button-group">
        <div class="action">
          @if (loading) {
          <app-spinner></app-spinner>
          } @else {
          <app-button variant="accent">
            <button [disabled]="!form.valid" type="submit" data-testid="email-otp-submit">{{ 'emailOtp.submit' | translate }}</button>
          </app-button>
          }
        </div>
        <app-button variant="secondary">
          <button type="button" data-testid="email-otp-resend" (click)="sendCode()">{{ 'emailOtp.resend' | translate }}</button>
        </app-button>
      </div>
    </form>
    }

    <div class="back">
      <a routerLink="/" queryParamsHandling="preserve">{{ 'emailOtp.back' | translate }}</a>
    </div>
  </div>
</app-layout>
